//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import { RegionFilter } from "shared/search/containers/Filter/Filters"

import {
    AgencyFederalRegionFilter,
    AgencyPublicOrganizationFilter,
    AgencyRegulationFilter,
} from "shared/search/containers/Filter/AgencyFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const AgencyAssociatedObjectsFilterGroups = (props) => genericFilterGroup(props)
AgencyAssociatedObjectsFilterGroups.propTypes = defaultPropTypes
AgencyAssociatedObjectsFilterGroups.defaultProps = {
    filters: [AgencyPublicOrganizationFilter, AgencyRegulationFilter],
    uniqueFilterGroupId: "AgencyAssociatedObjectsFilterGroups",
    displayLabel: "Underlying Data",
    helpText: "Filter by associated organization and/or regulation",
}

export const AgencyRegionFilterGroup = (props) => genericFilterGroup(props)
AgencyRegionFilterGroup.propTypes = defaultPropTypes
AgencyRegionFilterGroup.defaultProps = {
    filters: [RegionFilter, AgencyFederalRegionFilter],
    uniqueFilterGroupId: "agencyRegionFilterGroup",
    displayLabel: "Region",
    helpText: "Filter by agency region",
}
